import ImportService from 'api/import/importService';
import {
    default as importTypeDictionary,
    CASTING_TYPES,
} from 'Dictionaries/imports/ImportTypeDictionary';
import ImportStatusDictionary from 'Dictionaries/imports/ImportStatusDictionary';
import { defaultOptions } from 'Dictionaries/imports/importOptionsDictionary';

export const importStatus = {
    QUEUED: 'queued',
    PROCESSING: 'processing',
    PROCESSED: 'processed',
    CANCELLED: 'cancelled',
    REVERTING: 'reverting',
    REVERTED: 'reverted',
    FAILED: 'failed',
};
export const importProviders = {
    FLATFILE: 'flatfile',
    FLATFILE_PLATFORM: 'flatfile_platform',
    IMPORT_V2: 'import.v2',
};
export default {
    namespaced: true,
    state() {
        return {
            typeImport: null,
            optionsSelectedImport: {},
            optionsImport: {},
            metadataImport: [],
            genericImportMetadata: {},
            detailImport: null,
            importsList: [],
            isRestartImportNeeded: false,
            importUnlimited: false,
            nonGoldMaxLines: null,
            loadingMetadata: false,
            importSteps: [
                {
                    id: 1,
                    title: window.i18n.__('Quelles données souhaitez-vous importer ?'),
                },
                {
                    id: 2,
                    title: window.i18n.__('Préparer votre import'),
                },
                {
                    id: 3,
                    title: window.i18n.__('Paramétrer votre import'),
                    subSteps: [
                        {
                            id: 1,
                            title: window.i18n.__('Critères de comparaison'),
                            subTitle: window.i18n.__('Actions liées à la mise à jour'),
                            isValid: false,
                        },
                        {
                            id: 2,
                            title: window.i18n.__('Paramètres de l’import'),
                            subTitle: window.i18n.__('Actions liées à l’import'),
                            isValid: false,
                        },
                        {
                            id: 3,
                            title: window.i18n.__('Paramètres des champs personnalisés'),
                            subTitle: window.i18n.__('Actions liées aux champs personnalisés'),
                            isValid: false,
                        },
                    ],
                },
                {
                    id: 4,
                    title: '',
                },
            ],
            currentStepId: 1,
            currentSubStepId: null,
            hasCustomFields: false,
            customFields: [],
            pagination: { offset: null },
            hasDataForSetupStep: true,
        };
    },
    getters: {
        getCurrentStepId: (state) => state.currentStepId,
        getCurrentStep: (state) => {
            return state.importSteps.find((step) => step.id === state.currentStepId);
        },
        getLoadingMetadata: (state) => state.loadingMetadata,
        getCurrentSubStepId: (state) => state.currentSubStepId,
        getCurrentSubStep: (state) => {
            if (state.currentSubStepId === null) {
                return null;
            }
            return state.importSteps
                .find((step) => step.id === state.currentStepId)
                .subSteps.find((subStep) => subStep.id === state.currentSubStepId);
        },
        getImportSteps: (state) => state.importSteps,
        getTypeImport: (state) => state.typeImport,
        getOptionsSelectedImport: (state) => state.optionsSelectedImport,
        getOptionsImport: (state) => state.optionsImport,
        getMetadata: (state) => {
            return {
                insert_new_records: state.optionsSelectedImport.insert_new_records === 'Y',
                update_existing_records:
                    state.optionsSelectedImport.update_existing_records === 'Y',
                update_empty_fields: state.optionsSelectedImport.update_empty_fields === 'Y',
                overwrite_tags: state.optionsSelectedImport.overwrite_tags === 'Y',
                dismiss_required_custom_fields:
                    state.optionsSelectedImport.dismiss_required_custom_fields === 'Y',
                insert_new_custom_fields_enum_values:
                    state.optionsSelectedImport.insert_new_custom_fields_enum_values === 'Y',
                use_default_values_for_empty_custom_fields:
                    state.optionsSelectedImport.use_default_values_for_empty_custom_fields === 'Y',
                columns: state.columns ?? state.optionsSelectedImport.columns,
                identifiers: state.optionsSelectedImport.identifiers,
            };
        },
        getGenericImportMetadata: (state) => state.genericImportMetadata,
        getDetailImport: (state) => state.detailImport,
        getImportsList: (state) => state.importsList,
        getImportsListPagination: (state) => state.pagination,
        getMetadataImport: (state) => state.metadataImport,
        isImportUnlimited: (state) => state.importUnlimited,
        getNonGoldMaxLines: (state) => state.nonGoldMaxLines,
        getIsRestartImportNeeded: (state) => state.isRestartImportNeeded,
        getHasCustomFields: (state) => state.hasCustomFields,
        getCustomFields: (state) => state.customFields,
        getHasDataForSetupStep: (state) => state.hasDataForSetupStep,
    },
    mutations: {
        setLoadingMetadata: (state, loading) => (state.loadingMetadata = loading),
        setCurrentStepId: (state, step) => (state.currentStepId = step),
        setCurrentSubStepId: (state, subStep) => (state.currentSubStepId = subStep),
        setTypeImport(state, type) {
            state.typeImport = type;
        },
        setDetailImport(state, detail) {
            state.detailImport = detail;
        },
        setImportsList(state, importsList) {
            state.importsList = importsList;
        },
        setImportsPagination(state, pagination) {
            state.pagination = pagination;
        },
        setMetadataImport: (state, metadataImport) => (state.metadataImport = metadataImport),
        setGenericImportMetadata: (state, genericImportMetadata) =>
            (state.genericImportMetadata = genericImportMetadata),
        setImportProgress(state, detail) {
            const importToUpdate = state.importsList.find((item) => item.id === detail.id);
            if (state.detailImport) {
                Object.assign(state.detailImport, detail);
            }
            Object.assign(importToUpdate, detail);
        },
        setIsRestartImportNeeded(state, needed) {
            state.isRestartImportNeeded = needed;
        },
        setOptionsSelectedImport(state, options) {
            state.optionsSelectedImport = options;
        },
        setImportUnlimited(state, unlimited) {
            state.importUnlimited = unlimited;
        },
        setNonGoldMaxLines(state, limit) {
            state.nonGoldMaxLines = limit;
        },
        setOptionsImport(state, options) {
            state.optionsImport = options;
        },
        setHasCustomFields: (state, hasCustomFields) => (state.hasCustomFields = hasCustomFields),
        setCustomFields: (state, customFields) => (state.customFields = customFields),
        setFields: (state, fields) => (state.typeImport.fields = fields),
        setImportSteps: (state, steps) => (state.importSteps = steps),
        setHasDataForSetupStep: (state, hasDataForSetupStep) =>
            (state.hasDataForSetupStep = hasDataForSetupStep),
    },
    actions: {
        fetchImportsList({ commit, dispatch, getters }) {
            return new Promise((resolve, reject) => {
                ImportService.fetchImportsList(getters.getImportsListPagination.offset)
                    .then(async (response) => {
                        await dispatch('initImportMetadata');
                        commit('setImportsList', [...getters.getImportsList, ...response.data]);
                        commit('setImportsPagination', response.pagination);
                        resolve();
                    })
                    .catch((err) => {
                        commit('setImportsList', []);
                        reject(err);
                    });
            });
        },
        fetchImportDetail({ commit, getters }, importId) {
            return new Promise((resolve, reject) => {
                ImportService.fetchImportDetail(importId)
                    .then((response) => {
                        commit('setImportProgress', response);
                        commit('setDetailImport', response);
                        commit(
                            'setTypeImport',
                            getters.getMetadataImport.find((item) => item.type === response.type),
                        );
                        import(
                            `Dictionaries/imports/options/${getters.getTypeImport.optionsDictionary}.js`
                        ).then((module) => {
                            commit('setOptionsImport', module.options);
                            resolve();
                        });
                    })
                    .catch((error) => reject(error));
            });
        },
        async initImportMetadata({ commit }) {
            try {
                const metadataImport = [];
                const {
                    types: typesFromApi,
                    countries,
                    units,
                    currencies,
                    access_token: accessToken,
                } = await ImportService.fetchImportMetadata();
                for (const typeFromApi of typesFromApi) {
                    const itemFromDictionary = importTypeDictionary.find(
                        (item) => item.type === typeFromApi.type,
                    );
                    metadataImport.push({ ...itemFromDictionary, ...typeFromApi });
                }
                metadataImport;
                commit('setMetadataImport', metadataImport);
                commit('setGenericImportMetadata', { countries, units, currencies, accessToken });
            } catch (error) {
                throw new Error(error);
            }
        },
        resetDetail({ commit }) {
            commit('setDetailImport', null);
        },
        updateMetadataAfterImportEnd({ commit, getters }, importType) {
            const metaData = getters.getMetadataImport;
            metaData.map((data) => {
                if (data.type === importType) {
                    data.unavailable_reason = null;
                }
            });
            commit('setMetadataImport', metaData);
        },
        async updateImportList({ commit, getters, dispatch }, importDetail) {
            let importToUpdate = getters.getImportsList.find((item) => item.id === importDetail.id);
            if (importToUpdate === undefined) {
                if (importDetail.status === importStatus.PROCESSING) {
                    try {
                        const response = await ImportService.fetchImportDetail(importDetail.id);
                        const list = [response, ...getters.getImportsList];
                        // check if the import has not been added meanwhile
                        importToUpdate = getters.getImportsList.find(
                            (item) => item.id === importDetail.id,
                        );
                        if (importToUpdate === undefined) {
                            commit('setImportsList', list);
                            importToUpdate = response;
                        }
                    } catch (err) {
                        return;
                    }
                } else {
                    //We have to dispatch function when we received processed status
                    setTimeout(() => {
                        dispatch('updateImportList', importDetail);
                    }, 1000);
                    return;
                }
            }
            if (
                ImportStatusDictionary[importDetail.status].order <=
                    ImportStatusDictionary[importToUpdate.status].order &&
                importDetail.browsed_rows <= importToUpdate.browsed_rows
            ) {
                return;
            }
            commit('setImportProgress', importDetail);
        },
        updateIsRestartImportNeed({ commit }, isRestartImportNeeded) {
            commit('setIsRestartImportNeeded', isRestartImportNeeded);
        },
        updateTypeImport({ commit }, type) {
            commit('setTypeImport', type);
        },
        updateImportUnlimited({ commit }, importIsUnlimited) {
            commit('setImportUnlimited', importIsUnlimited);
        },
        updateNonGoldMaxLines({ commit }, maxLines) {
            commit('setNonGoldMaxLines', maxLines);
        },
        restartImport({ commit, state }) {
            // populates the store from the history as it was.
            const options = {};
            for (const [key, option] of Object.entries(state.detailImport._embed.metadata)) {
                if (key === 'columns' || key === 'identifiers') {
                    options[key] = option;
                } else {
                    options[key] = option ? 'Y' : 'N';
                }
            }
            commit('setOptionsSelectedImport', options);
            // when the store is populates we set the flag to restart
            commit('setIsRestartImportNeeded', true);
        },
        updateImportOptions({ commit, getters }) {
            import(
                `Dictionaries/imports/options/${getters.getTypeImport.optionsDictionary}.js`
            ).then((module) => {
                commit('setOptionsImport', module.options);
                const optionsSelected = {
                    ...defaultOptions,
                    ...module.defaultOptions,
                };
                commit('setOptionsSelectedImport', optionsSelected);
            });
        },
        updateLoadingMetadata({ commit }, loading) {
            commit('setLoadingMetadata', loading);
        },
        updateCurrentStepId({ commit }, stepId) {
            commit('setCurrentStepId', stepId);
        },
        updateCurrentSubStepId({ commit }, subStepId) {
            commit('setCurrentSubStepId', subStepId);
        },
        updateHasCustomFields({ commit }, hasCustomFields) {
            commit('setHasCustomFields', hasCustomFields);
        },
        updateCustomFields({ commit }, customFields) {
            const parser = new DOMParser();
            const customFieldsFlatFile = customFields.map((cf) => {
                let cfType;
                let metadata = {};
                let type = 'string';
                switch (cf.type) {
                    case 'numeric-with-unit':
                        cfType = 'unit';
                        break;
                    case 'company-individual':
                        cfType = 'third';
                        break;
                    case 'contact':
                        cfType = 'people';
                        break;
                    default:
                        cfType = cf.type.replace('-', '');
                        break;
                }
                switch (cf.type) {
                    case 'boolean':
                        type = 'boolean';
                        break;
                    case 'numeric':
                        type = 'number';
                        metadata = { castingType: CASTING_TYPES.INTEGER };
                        break;
                }

                return {
                    type,
                    key: `cf_${cfType}_${cf.id}`,
                    label: cf.name,
                    description: cf.description
                        ? parser.parseFromString(cf.description, 'text/html').body.textContent
                        : null,
                    metadata,
                };
            });
            commit('setCustomFields', customFieldsFlatFile);
        },
        updateFields({ commit }, fields) {
            commit('setFields', fields);
        },
        resetSubStepsValidity({ commit, state }) {
            const steps = state.importSteps.map((step) => {
                if (step.subSteps) {
                    for (const subStep of step.subSteps) {
                        subStep.isValid = false;
                    }
                }
                return step;
            });
            commit('setImportSteps', steps);
        },
        resetOptionsImport({ commit }) {
            commit('setOptionsImport', {});
            commit('setOptionsSelectedImport', {});
        },
        resetImport({ commit, dispatch }) {
            commit('setTypeImport', null);
            commit('setCurrentStepId', 1);
            commit('setCurrentSubStepId', null);
            commit('setIsRestartImportNeeded', false);
            commit('setHasDataForSetupStep', true);
            dispatch('resetSubStepsValidity');
            dispatch('resetOptionsImport');
        },
        resetImportList({ commit }) {
            commit('setImportsPagination', { offset: null });
            commit('setImportsList', []);
        },
        updateHasDataForSetupStep({ commit }, hasDataForSetupStep) {
            commit('setHasDataForSetupStep', hasDataForSetupStep);
        },
    },
};
